import gsap from 'gsap'
import Bouncer from 'formbouncerjs'

export const form = () => {

	/*
	const form = document.querySelector('form')

	if (!form) return

	const submit = form.querySelector('button')
	const validation = new Bouncer('form', {
		disableSubmit: true,
		messages: {
			missingValue: {
				default: (field) => {
					return field.getAttribute('data-required')
						? field.getAttribute('data-required')
						: 'This field is required.'
				}
			}
		}
	})

	document.addEventListener('bouncerFormValid', (event) => {
		const params = new FormData(form)
		submit.classList.add('loading')
		fetch('/contact-form/send', {
			method: 'POST',
			headers: {
				Accept: 'application/json'
			},
			body: params
		})
		.then((response) => response.json())
		.then((response) => {
			form.reset()
			submit.classList.remove('loading')
			showSuccessMessage(response.message)
		})
	}, false)

	const showSuccessMessage = (message) => {
		const el = document.createElement('div')
		el.style.opacity = '0'
		el.innerHTML = `<span>${message}</span>`
		el.classList.add('success-message')
		form.appendChild(el)
		gsap.fromTo(el, { y: 100, opacity: 0 }, { duration: 0.6, y: 0, opacity: 1, ease: 'power2.out' })
	}

	*/

}

export default () => {}
